import CCTicketIcon from '@/Assets/Images/Svgs/CCTicketIcon';
import Box from '@/Atoms/Box';
import CCButton from '@/Atoms/CCButton';
import CCText from '@/Atoms/CCText';
import CCColors, {updateColorWithOpacity} from '@/Utils/CCColors';
import {FontSizes, vs} from '@/Utils/Dimensions';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import {getValidTimezone} from '@/Utils/CommonUtils';

dayjs.extend(utc);
dayjs.extend(timezone);

import React from 'react';
import {Image, Platform} from 'react-native';
import {RFPercentage} from 'react-native-responsive-fontsize';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';

const TournamentRow = ({
  item,
  rowIndex,
  activeTab,
  handleRowPress,
  timeControlToSvgAndColor,
  isMobileOrTab,
  userId,
  userData,
  isHighlighted = false,
}) => {
  const [durationStr, incrementStr] = item.time_control.split('+');
  const duration = parseInt(durationStr) * 60000; // Convert to ms
  const increment = parseInt(incrementStr) * 1000; // Convert to ms
  function classifyTimeControl(duration: number, increment: number) {
    const totalTime = (duration + increment) / 60000;

    if (totalTime < 3) {
      return 'Bullet';
    } else if (totalTime < 10) {
      return 'Bolt';
    } else if (totalTime < 30) {
      return 'Rapid';
    } else {
      return 'Snail';
    }
  }
  // Get category
  const category = classifyTimeControl(duration, increment);
  const joined = item.is_joined;

  const {svg: SvgComponent, color: desiredColor} =
    timeControlToSvgAndColor[category];

  const startTime: any = new Date(item.start_date);
  const userTimezone = getValidTimezone(userData?.user_timezone?.selected);

  const tournamentTime = dayjs(startTime)
    .tz(userTimezone)
    .format('ddd, MMM D, h:mm A');

  const now = new Date();
  const timeDifference = startTime - now; // Difference in milliseconds
  const diffDays = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  const diffHours = Math.floor(
    (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
  );
  const diffMinutes = Math.floor(
    (timeDifference % (1000 * 60 * 60)) / (1000 * 60),
  );

  const [day, date, time] = tournamentTime.split(', ');

  // Create the "startingIn" string
  const startingIn =
    timeDifference > 0
      ? diffDays > 0
        ? `${diffDays}d ${diffHours}h`
        : diffHours > 0
        ? `${diffHours} hrs ${diffMinutes} mins`
        : `${diffMinutes} mins`
      : item.is_active
      ? 'In progress'
      : 'Finished';

  return (
    <Box
      key={rowIndex}
      flexDirection="row"
      style={{width: '100%'}}
      onPress={() => {
        handleRowPress(item);
      }}>
      <Box
        style={{
          padding: vs(10),
          width: !isMobileOrTab ? '18%' : '24%',
          backgroundColor: isHighlighted
            ? updateColorWithOpacity('#FACF47', 0.7)
            : CCColors.CCTableBg,
          // backgroundColor: isHighlighted ? CCColors.HighlightColor : CCColors.CCTableBg,
          borderRightColor: CCColors.BorderLight,
          borderRightWidth: 1,
        }}>
        <CCText
          color={CCColors.TextColor.LightGrey}
          fontWeight={500}
          fontSize={FontSizes[14]}>
          {time}
        </CCText>
        {/* {activeTab !== 'upcoming' && ( */}
        <CCText color={CCColors.TextColor.LightGrey} fontSize={FontSizes[10]}>
          {date}
        </CCText>
        {/* )} */}
      </Box>
      <Box
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        style={{
          backgroundColor:
            item.id === 1591
              ? CCColors?.TextColor?.Dark
              : isHighlighted
              ? updateColorWithOpacity('#FACF47', 0.65)
              : undefined,
          // backgroundColor: item.id === 1591 ? CCColors?.TextColor?.Dark : isHighlighted ? CCColors.HighlightColor : undefined,
          paddingVertical: vs(15),
          paddingLeft: vs(10),
          width: '76%',
          borderBottomWidth: 1,
          borderBottomColor: CCColors.BorderLight,
        }}>
        {item.id === 1591 && (
          <Image
            source={require('@/Assets/Images/Svgs/tournament_banner/detail_pattern.svg')}
            style={{position: 'absolute', left: -27, width: 130, height: 100}}
          />
        )}
        <Box
          flexDirection="row"
          style={{flex: 1, paddingLeft: Platform.OS === 'web' && 10}}>
          <Box
            justifyContent="center"
            alignItems="center"
            style={{
              borderRadius: 20,
              height: 32,
              width: 32,
              backgroundColor:
                item.id === 1591 ? CCColors?.Purple : desiredColor,
              marginRight: 10,
            }}>
            {SvgComponent}
          </Box>
          <Box flexDirection="column" style={{width: '80%'}}>
            <CCText
              color={
                item.id === 1591
                  ? CCColors?.White
                  : CCColors.TextColor.LightGrey
              }
              fontWeight={500}
              fontSize={!isMobileOrTab ? FontSizes[14] : RFPercentage(1.6)}>
              {item?.name?.length > 40
                ? item.name.trim().slice(0, 40) + '...'
                : item.name}
            </CCText>
            <Box style={{flexDirection: 'row', gap: 5, alignItems: 'center'}}>
              <CCText
                color={
                  item.id === 1591
                    ? CCColors?.White
                    : CCColors.TextColor.LightGrey
                }
                fontSize={!isMobileOrTab ? FontSizes[12] : RFPercentage(1.2)}>
                {item.time_control} |
              </CCText>
              {item.is_free ? (
                <Box
                  style={{
                    backgroundColor: updateColorWithOpacity(
                      CCColors?.Primary?.Default,
                      0.4,
                    ),
                    paddingHorizontal: 8,
                    paddingVertical: 2,
                    borderRadius: 34,
                  }}>
                  <CCText
                    color={
                      item.id === 1591
                        ? CCColors?.White
                        : CCColors.TextColor.LightGrey
                    }
                    fontSize={
                      !isMobileOrTab ? FontSizes[12] : RFPercentage(1.2)
                    }
                    style={{
                      fontWeight: '600',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 3,
                    }}>
                    <CCTicketIcon
                      width={isMobileOrTab ? 12 : 14}
                      height={isMobileOrTab ? 12 : 14}
                      color={
                        item.id === 1591
                          ? CCColors?.White
                          : CCColors.TextColor.LightGrey
                      }
                    />{' '}
                    Free
                  </CCText>
                </Box>
              ) : (
                <CCText
                  color={
                    item.id === 1591
                      ? CCColors?.White
                      : CCColors.TextColor.LightGrey
                  }
                  fontSize={!isMobileOrTab ? FontSizes[12] : RFPercentage(1.2)}>
                  {item.rounds} rounds
                </CCText>
              )}
              {!!item.cash_prize && (
                <Box
                  style={{
                    backgroundColor: updateColorWithOpacity(
                      CCColors?.Primary?.Default,
                      0.4,
                    ),
                    paddingHorizontal: 8,
                    paddingVertical: 2,
                    borderRadius: 34,
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'row',
                    gap: 3,
                  }}>
                  <Box
                    style={{
                      width: isMobileOrTab ? 12 : 16,
                      height: isMobileOrTab ? 12 : 16,
                      borderRadius: isMobileOrTab ? 6 : 10,
                      borderWidth: 1.25,
                      borderColor:
                        item.id === 1591
                          ? CCColors?.White
                          : CCColors?.TextColor?.Primary,
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}>
                    <MaterialCommunityIcons
                      name="currency-inr"
                      size={isMobileOrTab ? 10 : 14}
                      color={
                        item.id === 1591
                          ? CCColors?.White
                          : CCColors.TextColor.Primary
                      }
                    />
                  </Box>
                  <CCText
                    color={
                      item.id === 1591
                        ? CCColors?.White
                        : CCColors.TextColor.LightGrey
                    }
                    fontSize={
                      !isMobileOrTab ? FontSizes[12] : RFPercentage(1.2)
                    }
                    style={{fontWeight: '600'}}>
                    {item.cash_prize.toLocaleString('en-IN')}
                  </CCText>
                </Box>
              )}
            </Box>
          </Box>
        </Box>

        <Box
          alignItems="flex-end"
          justifyContent="center"
          style={{paddingRight: Platform.OS === 'web' && 10}}>
          {activeTab === 'upcoming' ? (
            joined ? (
              <Box style={{width: '100%', height: '100%'}}>
                <Box
                  pointerEvents="none"
                  style={{
                    backgroundColor: CCColors.BlueAqua,
                    borderRadius: '50%',
                    height: !isMobileOrTab ? 32 : 24,
                    width: !isMobileOrTab ? 32 : 24,
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}>
                  <MaterialCommunityIcons
                    name="check"
                    color={CCColors.White}
                    size={18}
                  />
                </Box>
              </Box>
            ) : (
              <Box
                justifyContent="center"
                alignItems="center"
                style={{
                  borderRadius: !isMobileOrTab ? '50%' : 20,
                  height: !isMobileOrTab ? 32 : 24,
                  width: !isMobileOrTab ? 32 : 24,
                  backgroundColor: CCColors.Primary.Default,
                }}>
                {!item.is_free && !item.is_registered ? (
                  <MaterialCommunityIcons
                    color={CCColors.Primary.Dark}
                    name={'archive-edit'}
                    size={18}
                    style={{fontWeight: 'bold'}}
                    onPress={() => handleRowPress(item)}
                  />
                ) : (
                  <MaterialCommunityIcons
                    color={CCColors.Primary.Dark}
                    name={item.is_private ? 'lock' : 'arrow-right'}
                    size={18}
                    style={{fontWeight: 'bold'}}
                  />
                )}
              </Box>
            )
          ) : (
            <Box
              justifyContent="center"
              alignItems="center"
              style={{
                borderRadius: !isMobileOrTab ? '50%' : 20,
                height: !isMobileOrTab ? 32 : 24,
                width: !isMobileOrTab ? 32 : 24,
                backgroundColor: CCColors.Primary.Default,
              }}>
              <MaterialCommunityIcons
                color={CCColors.Primary.Dark}
                name={'grid-large'}
                size={!isMobileOrTab ? 20 : 16}
                style={{fontWeight: 'bold'}}
              />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default TournamentRow;
